import { Panel } from "@/components/AppShell";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function Replacements({ ctx, outIds, material, reps, setReps }) {
  const bench = ctx.players.filter((p) => !p.starter && !outIds.includes(p.id));
  const slots = [0, 1].map((i) => reps[i] || { pid: "", min: "" });
  const update = (i, patch) => setReps(slots.map((s, j) => (j === i ? { ...s, ...patch } : s)).filter((s) => s.pid || s.min !== ""));
  return (
    <Panel className={`p-4 ${material ? "" : "opacity-60"}`} data-testid="rotation-replacements">
      <h3 className="font-display text-xl font-bold uppercase tracking-wide">Replacements</h3>
      <p className="text-xs text-slate-400 mb-3">
        {material ? "Up to two bench players. Enter their NEW TOTAL minutes (0–48); the rest is redistributed to 240."
          : "Only for an OUT player averaging 10+ minutes. Smaller absences remove the player without redistribution."}
      </p>
      {slots.map((s, i) => (
        <div key={i} className="flex gap-2 mb-2">
          <Select value={s.pid || "none"} onValueChange={(v) => update(i, { pid: v === "none" ? "" : v })} disabled={!material}>
            <SelectTrigger data-testid={`rotation-rep-player-${i}`} className="flex-1 min-w-0 bg-slate-900/70 [&>span]:truncate"><SelectValue placeholder="Bench player" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="none">— none —</SelectItem>
              {bench.filter((p) => p.id === s.pid || !slots.some((o) => o.pid === p.id)).map((p) => (
                <SelectItem key={p.id} value={p.id}>{p.name} · {p.games ? `${p.avg_min} min/g` : "no season MIN · pooled rate"}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          <Input data-testid={`rotation-rep-min-${i}`} type="number" min="0" max="48" step="0.1" placeholder="MIN" value={s.min} disabled={!material || !s.pid}
            onChange={(e) => update(i, { min: e.target.value })} className="w-20 shrink-0 bg-slate-900/70 font-mono-num" />
        </div>
      ))}
    </Panel>
  );
}
